import React from "react";
import type { ViewComponent } from "@frui.ts/views/dist";
import { registerView } from "@frui.ts/views/dist";
import { observer } from "mobx-react-lite";
import CreateView from "views/common/create";
import MunicipalityCreateViewModel from "viewModels/timeCharges/distributorEnums/municipalities/municipalityCreateViewModel";
import MunicipalityForm from "./municipalityForm";

const MunicipalityCreateView: ViewComponent<MunicipalityCreateViewModel> = observer(({ vm }) => (
  <CreateView vm={vm} form={<MunicipalityForm vm={vm} />} />
));

registerView(MunicipalityCreateView, MunicipalityCreateViewModel);
